export default __webpack_public_path__ + "static/media/shamvalley.05dbcc6c.jpg";